import { CheckInTheme } from '@/types/checkin'

export const DEFAULT_CHECKIN_THEMES: CheckInTheme[] = [
  { colorIndex: 1, name: 'Communication', count: 1 },
  { colorIndex: 2, name: 'Impact', count: 1 },
  { colorIndex: 3, name: 'Process', count: 1 },
  { colorIndex: 4, name: 'Support', count: 1 },
  { colorIndex: 5, name: 'Teamwork', count: 1 }
]
